export default {
  computed: {
    isEcoExperience() {
      const unitAgnosticPages = [
        'Login',
        'LockedLogin',
        'SSOAuth',
        'SSORedirect',
        'EligibilityQuestionsStep',
        'RegisterAccountStep',
        'MemberStep',
        'InsuranceStep',
        'SubscriberStep',
        'GuardianStep',
        'DeleteAccount',
        'DeleteAccountSuccess',
        'DeleteAccountExpired',
        'DeleteAccountFinalized',
        'DeleteAccount',
        'PasswordRecovery',
        'PasswordRecoverySuccess',
        'PasswordReset',
        'PasswordResetExpired',
        'PasswordResetSuccess',
        'RegistrationSuccess',
        'RegistrationError',
        'RegistrationStepError',
        'RegistrationConnectionError',
        'Programs',
        'ProgramDetail',
        'Wizard',
      ];

      return unitAgnosticPages.includes(this.$route.name);
    },
  },
};


